import { commonColors } from "./constants"

const TabPrimaryColor = '#dccb03'
const darkTextPrimary = '#FFFFFF'
const darkBackgroundColor = '#0F162B'

// const dark1 = '#181818'
const dark1 = '#000'
const dark2 = '#505050'
const dark3 = '#000'
const dark5 = '#333333'
const dark8 = '#68799F'
const dark9 = '#202020'

export const darkColors = {
    ...commonColors,
    appBackground: `linear-gradient(165deg, ${dark3} 4%, ${dark1} 96%)`,
    pageHeaderBackground: `linear-gradient(180deg, ${dark1} 0.52%, ${dark1} 100%)`,
    dark1: dark1,
    dark2: dark2,
    dark3: dark3,
    dark4: '#202020',
    dark5: dark5,
    dark6: '#101C3E',
    dark7: '#232B40',
    dark8: dark8,
    dark9:dark9,
    dark10:'#a8e3c6',
    darkMain: '#202020', /* Header Section */
    TabPrimaryColor:TabPrimaryColor,
    textPrimary: darkTextPrimary,
    textSecondary: '#A2A6B1',
    HoverButtonBorder: '#968b09',
    paragraphColor: '#A1A7BB',
    tooltip:dark8,
    divider: dark5,
    backdrop: darkBackgroundColor+'66',
    disabled: darkTextPrimary+'4d',
    icon: darkTextPrimary+'4d',
    // headerBorder: dark2,
    headerBorder: '#434343',
    paperBorder: {
      boxShadow: `0 0 0 1px ${dark5} inset`
    },
    // research
    prograssBarColor: TabPrimaryColor,
    prograssBarBackground: 'black',
    selectedItem: darkTextPrimary,
    datasetBorder: dark2,
    //dashboard
    treemapBackground: dark2
  }


// const dark1 = '#0B132B'
// const dark2 = '#17213E'
// const dark3 = '#202C4D'
// const dark5 = '#394C76'
// const dark8 = '#68799F'